import jwtDecode from "jwt-decode";

export function CommonToken() {
  const token = localStorage.getItem("authorizeToken");


  if (token) {
    try {
      // Step 2: Verify the JWT on the client-side
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;
     
      if (decoded.exp < currentTime) {
        // JWT has expired, so remove it from storage and redirect to login page
        localStorage.removeItem("authorizeToken");
        // window.location.href = "/login";
        return { status: false };
      } else {
        // JWT is still valid, so set it as an authentication header for all requests

        return { status: true, token: token };
      }
    } catch (error) {
      // JWT is invalid, so remove it from storage and redirect to login page
      localStorage.removeItem("authorizeToken");
      // window.location.href = "/login";
      return { status: false };
    }
  } else {
    return { status: false };
  }
}
